import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Paper,
  Snackbar,
  Alert,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from '@mui/material';
import { Add } from '@mui/icons-material';
import GeneralSettings from '../../GeneralSettings/GeneralSettings';
import MainContentContainer from "../../MainContentContainer/MainContentContainer";

const GeneralSettingsPage = () => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });
  const [isNewDialogOpen, setIsNewDialogOpen] = useState(false);
  const [newSettingName, setNewSettingName] = useState('');
  const [triggerNewSetting, setTriggerNewSetting] = useState(false);

  const handleCloseSnackbar = () => {
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  const handleActionComplete = (success, message) => {
    setSnackbar({
      open: true,
      message,
      severity: success ? 'success' : 'error'
    });
  };

  const handleOpenNewDialog = () => {
    setIsNewDialogOpen(true);
  };

  const handleCloseNewDialog = () => {
    setIsNewDialogOpen(false);
    setNewSettingName('');
    setTriggerNewSetting(false);
  };

  const handleCreateNewSetting = () => {
    if (newSettingName.trim()) {
      // Trigger the GeneralSettings component to create the new setting
      setTriggerNewSetting(true);
    }
  };

  const handleNewSettingCreated = () => {
    setTriggerNewSetting(false);
    handleCloseNewDialog();
  };

  return (
    <MainContentContainer>
      <AppBar position="sticky">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            General App Settings
          </Typography>
          <Button
            color="inherit"
            onClick={handleOpenNewDialog}
            startIcon={<Add />}
            sx={{
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)'
              }
            }}
          >
            New Setting
          </Button>
        </Toolbar>
      </AppBar>

      <Box sx={{ mt: 3 }}>
        <Paper sx={{ p: 3 }}>
          <GeneralSettings
            onActionComplete={handleActionComplete}
            newSettingName={triggerNewSetting ? newSettingName : ''}
            onNewSettingCreated={handleNewSettingCreated}
          />
        </Paper>
      </Box>

      <Dialog
        open={isNewDialogOpen}
        onClose={handleCloseNewDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Create New Setting</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Setting Name"
            fullWidth
            value={newSettingName}
            onChange={(e) => setNewSettingName(e.target.value)}
            placeholder="Enter setting name..."
            variant="outlined"
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseNewDialog}>Cancel</Button>
          <Button
            onClick={handleCreateNewSetting}
            variant="contained"
            color="primary"
            disabled={!newSettingName.trim()}
          >
            Create
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </MainContentContainer>
  );
};

export default GeneralSettingsPage; 